import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { MainState } from './state';

const defaultState: MainState = {
  isLoggedIn: null,
  token: '',
  logInError: false,
  logInErrorCause: null,
  userProfile: null,
  dashboardMiniDrawer: false,
  dashboardShowDrawer: true,
  notifications: [],
  userPhotoProfile: null,
  selected_account: 0,
  ownerProfile: null,
  employeeProfile: null,
  selectedBranch: 0,
  mediaUploaded: [],
  currentAccount: null,
  ingredients: [],
  autoCompleteIngredients: [],
  defaultCurrency: null,
  defaultLanguage: null,
  accountState: null,
  currentSelectedBranch: null,
  showOverlayLoadingIndicator: false,
  currentSponsor: null,
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
